import { render, staticRenderFns } from "./CampaignDateTime.vue?vue&type=template&id=8c235480&"
import script from "./CampaignDateTime.vue?vue&type=script&lang=js&"
export * from "./CampaignDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports